module.exports = __webpack_public_path__ + "static/media/romanian_pzl11.5f4ce394.png";